/* Reference page for the detection reasons (/ai-detection-reasons).

   Three things need script: the search and group filter over the 28 term cards,
   the button that copies a link to one definition, and the deep link that opens
   the page on a definition even when a filter would have hidden it.

   The cards themselves are rendered server-side, so the page is complete and
   readable with this file blocked. The FAQ accordion is the site's own and is
   driven by ios-cleaner.js. */
(function () {
    'use strict';

    var root = document.querySelector('.reasons');
    if (!root) return;

    var terms = Array.prototype.slice.call(root.querySelectorAll('.term'));
    var groupSections = Array.prototype.slice.call(root.querySelectorAll('.gl-group'));
    var searchBox = document.getElementById('glSearch');
    var searchWrap = document.getElementById('glSearchWrap');
    var clearBtn = document.getElementById('glClear');
    var countEl = document.getElementById('glCount');
    var emptyEl = document.getElementById('glEmpty');
    var groupBtns = Array.prototype.slice.call(root.querySelectorAll('#glGroups button'));
    var toast = document.getElementById('reasonsToast');
    var activeGroup = 'all';

    /* ---------- search and group filter ---------- */
    function applyFilter() {
        var q = searchBox ? searchBox.value.trim().toLowerCase() : '';
        if (searchWrap) searchWrap.classList.toggle('has-value', q.length > 0);

        var shown = 0;
        terms.forEach(function (t) {
            var okGroup = activeGroup === 'all' || t.dataset.group === activeGroup;
            var okText = !q || t.dataset.search.indexOf(q) !== -1;
            var show = okGroup && okText;
            t.classList.toggle('hidden', !show);
            if (show) shown++;
        });

        groupSections.forEach(function (s) {
            var any = Array.prototype.some.call(s.querySelectorAll('.term'), function (t) {
                return !t.classList.contains('hidden');
            });
            s.classList.toggle('hidden', !any);
        });

        if (countEl) {
            countEl.textContent = shown === terms.length
                ? terms.length + ' reasons'
                : shown + ' of ' + terms.length + ' shown';
        }
        if (emptyEl) emptyEl.classList.toggle('on', shown === 0);
    }

    if (searchBox) {
        searchBox.addEventListener('input', applyFilter);
        searchBox.addEventListener('keydown', function (e) {
            if (e.key === 'Escape') { searchBox.value = ''; applyFilter(); }
        });
    }
    if (clearBtn) {
        clearBtn.addEventListener('click', function () {
            searchBox.value = '';
            applyFilter();
            searchBox.focus();
        });
    }
    groupBtns.forEach(function (b) {
        b.addEventListener('click', function () {
            activeGroup = b.dataset.group;
            groupBtns.forEach(function (x) {
                var on = x === b;
                x.classList.toggle('active', on);
                x.setAttribute('aria-pressed', on ? 'true' : 'false');
            });
            applyFilter();
            /* Filtering hides most of the page, and a reader who was deep in
               the list would be left standing in the footer of the now-short
               page. Take them to the start of what the filter kept - the
               groups carry the same scroll margin the anchors use, so the
               heading lands under the sticky band, not beneath it. */
            var firstShown = root.querySelector('.gl-group:not(.hidden)');
            if (firstShown) {
                firstShown.scrollIntoView({
                    behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
                    block: 'start'
                });
            }
        });
    });

    /* ---------- copy a link to one definition ---------- */
    var toastTimer = 0;
    function showToast(msg) {
        if (!toast) return;
        toast.textContent = msg;
        toast.classList.add('on');
        window.clearTimeout(toastTimer);
        toastTimer = window.setTimeout(function () { toast.classList.remove('on'); }, 1800);
    }

    /* The clipboard API is the good path, but it refuses without a permission
       or without user activation, and it is absent over plain http. Falling
       back to a hidden textarea covers all three; the button only reports a
       failure when both ways fail. */
    function legacyCopy(text) {
        return new Promise(function (resolve, reject) {
            var ta = document.createElement('textarea');
            ta.value = text;
            ta.setAttribute('readonly', '');
            ta.style.cssText = 'position:fixed;top:-1000px;opacity:0';
            document.body.appendChild(ta);
            ta.select();
            var ok = false;
            try { ok = document.execCommand('copy'); } catch (e) { ok = false; }
            document.body.removeChild(ta);
            if (ok) resolve(); else reject(new Error('copy failed'));
        });
    }

    function writeClipboard(text) {
        if (navigator.clipboard && window.isSecureContext) {
            return navigator.clipboard.writeText(text).catch(function () { return legacyCopy(text); });
        }
        return legacyCopy(text);
    }

    root.querySelectorAll('.copy-link').forEach(function (btn) {
        btn.addEventListener('click', function () {
            var slug = btn.dataset.slug;
            /* the address of this page, whichever host is serving it */
            var url = location.origin + location.pathname + '#' + slug;
            writeClipboard(url).then(function () {
                btn.classList.add('done');
                window.setTimeout(function () { btn.classList.remove('done'); }, 1800);
                showToast('Link copied');
                try { history.replaceState(null, '', '#' + slug); } catch (e) {}
            }).catch(function () {
                showToast('Copy failed — the link is ' + url);
            });
        });
    });

    /* ---------- anchor offset under the sticky band ---------- */
    /* A jump to #some-term must leave the heading visible: the controls band
       is sticky and, on a phone, several rows tall. Its real height (plus its
       own sticky offset - the site header) becomes the scroll margin of every
       anchor target; the browser honours it for native hash jumps and for
       scrollIntoView alike. Re-measured on resize: the pills wrap. */
    var controlsBand = root.querySelector('.gl-controls');
    function setAnchorOffset() {
        if (!controlsBand) return;
        var stickyTop = parseFloat(getComputedStyle(controlsBand).top) || 0;
        var offset = Math.round(stickyTop + controlsBand.offsetHeight + 12);
        document.documentElement.style.setProperty('--gl-anchor-offset', offset + 'px');
    }
    setAnchorOffset();
    window.addEventListener('resize', setAnchorOffset);

    /* ---------- deep links ---------- */
    function focusTerm(slug, behavior) {
        var el = document.getElementById(slug);
        if (!el || !el.classList.contains('term')) return;

        /* a link can point at a definition the current filter hides, so clear
           the filter before scrolling to it */
        if (el.classList.contains('hidden')) {
            if (searchBox) searchBox.value = '';
            activeGroup = 'all';
            groupBtns.forEach(function (x) {
                var on = x.dataset.group === 'all';
                x.classList.toggle('active', on);
                x.setAttribute('aria-pressed', on ? 'true' : 'false');
            });
            applyFilter();
        }

        terms.forEach(function (t) { t.classList.remove('is-target'); });
        el.classList.add('is-target');
        el.scrollIntoView({ behavior: behavior || 'smooth', block: 'start' });
    }

    window.addEventListener('hashchange', function () { focusTerm(location.hash.slice(1)); });

    /* On first load the fonts are still arriving and the page grows under the
       scroll position, so wait for them and then jump without an animation. */
    function openFromHash() {
        if (location.hash.length > 1) focusTerm(location.hash.slice(1), 'auto');
    }
    if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(function () { window.setTimeout(openFromHash, 60); });
    } else {
        window.addEventListener('load', function () { window.setTimeout(openFromHash, 60); });
    }

    applyFilter();
})();
